import './TakeOrderNew.css';
import React from 'react';
import Header from '../components/Header';
import { useState, useEffect } from 'react';
import ItemCard from '../components/ItemCard';
import OrderItemNew from '../components/OrderItemNew';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import CancelButton from '../components/CancelButton';
import Button from '../components/Button';

function TakeOrderNew() {

    const [currentOrder, setCurrentOrder] = useState([]);
    const [currentItemNum, setCurrentItemNum] = useState(1);
    const [mealBeingAddedTo, setMealBeingAddedTo] = useState(-1);
    const [currentTotal, setCurrentTotal] = useState(0);
    const [allMealsValid, setAllMealsValid] = useState(true);
    const [orderType, setOrderType] = useState('dinein');
    const [foodItems, setFoodItems] = useState([]);
    const [fetchError, setFetchError] = useState(0);

    let location = useLocation();

    useEffect(() => {
        if (location.state) {
            if (location.state.order && location.state.total) {
                setCurrentOrder(location.state.order)
                setCurrentTotal(location.state.total)
                setCurrentItemNum(location.state.currentItemNum);
            } 
            if (location.state.orderType) {
                setOrderType(location.state.orderType)
            }
        }
    }, [location]);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/items`,{
            withCredentials: true,
            credentials: 'include',
        })
            .then(response => {
                if (!response.ok) {
                    setFetchError(response.status);
                    console.log(response.status);
                    throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.json();
            })
            .then(data => {
                setFoodItems(data);
            })
            .catch(err => {
                setFetchError(500);
                console.log(err);
            });
    }, [])

    function cancelOrder() {
        setCurrentOrder([]);
        setCurrentItemNum(1);
        setMealBeingAddedTo(-1);
        setCurrentTotal(0);
        setAllMealsValid(true);
    }

    function addNewMeal(isWorker) {
        let newMeal = {}
        newMeal.isWorkerMeal = isWorker;
        newMeal.itemType = 'meal';
        newMeal.orderNum = currentItemNum;
        newMeal.order = {};
        newMeal.order.entrees = [];
        newMeal.order.sides = [];
        newMeal.order.extras = [];
        newMeal.price = 0;
        newMeal.foodID = isWorker ? foodItems.filter(i => i.name === 'Worker Meal')[0].foodid : foodItems.filter(i => i.name === 'Meal')[0].foodid
        newMeal.isValid = false;
        setCurrentItemNum(currentItemNum + 1);
        setCurrentOrder([...currentOrder, newMeal]);
        setAllMealsValid(false);
        setMealBeingAddedTo(newMeal.orderNum);
        
    }

    function addItem(itemType, itemName, price, foodID, mealPrice=0) {
        if (mealBeingAddedTo > 0) {
            let currMeal = currentOrder.filter(i => i.orderNum === mealBeingAddedTo)[0];
            let otherMeals = currentOrder.filter(i => i.orderNum !== mealBeingAddedTo);
            if (itemType === 'entree') {
                if (currMeal.order.entrees.length === 0) {
                    currMeal.price = currMeal.isWorkerMeal ? mealPrice / 2 : mealPrice;
                    setCurrentTotal(currentTotal + currMeal.price);
                    currMeal.order.entrees.push({item: itemName, foodID: foodID});
                } else if (currMeal.isWorkerMeal) {
                    currMeal.order.entrees.push({item: itemName, foodID: foodID});
                }
            }
            else if (itemType === 'side') {
                if (currMeal.order.sides.length < 2 || currMeal.isWorkerMeal) {
                    currMeal.order.sides.push({item: itemName, foodID: foodID});
                }
            }
            else {
                if (currMeal.isWorkerMeal) {
                    currMeal.order.extras.push({item: itemName, foodID: foodID});
                }
            }
            setCurrentOrder([...otherMeals, currMeal])
            let valid = isMealValid(currMeal.orderNum);
            currMeal.isValid = valid;
            setAllMealsValid(areAllMealsValid());
            if (valid) {
                setMealBeingAddedTo(-1);
            }
            

        } else {
            let newItem = {}
            newItem.orderNum = currentItemNum;
            newItem.itemType = 'alacarte';
            newItem.order = {item: itemName, foodID: foodID};
            newItem.price = price;
            setCurrentOrder([...currentOrder, newItem]);
            setCurrentTotal(currentTotal + newItem.price);
            setCurrentItemNum(currentItemNum + 1);
        }
    }

    function deleteItem(id) {
        let toDelete = currentOrder.filter(i => i.orderNum === id)[0];
        let restOfOrder = currentOrder.filter(i => i.orderNum !== id);
        setCurrentTotal(currentTotal - toDelete.price);
        setCurrentOrder(restOfOrder);
        
    }

    function deleteMealItem(id, itemName, category) {
        
        let toDelete = currentOrder.filter(i => i.orderNum === id)[0];
        let restOfOrder = currentOrder.filter(i => i.orderNum !== id);
        if (category === 'entree') {
            let entreeToRemove = toDelete.order.entrees.findIndex(i => i.item === itemName);
            if (entreeToRemove !== -1) {
                if (toDelete.order.entrees.length === 1) {
                    setCurrentTotal(currentTotal - toDelete.price);
                    toDelete.price = 0;
                }
                toDelete.order.entrees.splice(entreeToRemove, 1);
            }
        } else if (category === 'side') {
            let sideToRemove = toDelete.order.sides.findIndex(i => i.item === itemName);
            if (sideToRemove !== -1) {
                toDelete.order.sides.splice(sideToRemove, 1);
            }            
        } else {
            let extraToRemove = toDelete.order.extras.findIndex(i => i.item === itemName);
            if (extraToRemove !== -1) {
                toDelete.order.extras.splice(extraToRemove, 1);
            }
        }
        setCurrentOrder([...restOfOrder, toDelete]);
        let valid = isMealValid(toDelete.orderNum);
        toDelete.isValid = valid;
        setAllMealsValid(areAllMealsValid());
        
    }

    function isMealValid(id) {
        
        let meal = currentOrder.filter(i => i.orderNum === id)[0];
        let valid = true;
        if (meal.itemType === 'meal') {
            if (orderType === 'drivethru') {
                if (meal.order.entrees.length === 0 || meal.order.sides.length < 2) {
                    valid = false;
                }
            } else {
                if (meal.order.entrees.length === 0) {
                    valid = false;
                }
            }
            
            if (!meal.isWorkerMeal && (meal.order.entrees.length > 1 || meal.order.sides.length > 2 || meal.order.extras.length > 0)) {
                valid = false;
            }
        }
        console.log(valid);
        return valid;
    }

    function setAddMeal(id) {
        setMealBeingAddedTo(id);
    }

    function areAllMealsValid() {
        let allValid = true;
        for (let item of currentOrder) {
            if (item.itemType === 'meal') {
                if (!isMealValid(item.orderNum)) {
                    allValid = false;
                }
            }
        }
        return allValid;
    }

    return (
        <div>
            <Header />
            <div className='main-order-div'>
                <div className='top-div'>
                    <h3 className='order-type-text'>Order type: {orderType}</h3>
                    {
                        allMealsValid && mealBeingAddedTo < 0 ? <div className='new-meal'>
                            <h3 className='start-meal-text' style={{margin: "10px"}}>Start a meal, or select a la carte items:</h3>
                            <div className='meal-buttons'>
                                <Button buttonText='New Meal' onClickFunction={() => addNewMeal(false)}/>
                                <Button buttonText='New Worker Meal' onClickFunction={() => addNewMeal(true)}/>
                            </div>
                        </div> : mealBeingAddedTo < 0 ? <div className='invalid-meals'>
                            {
                                orderType === 'drivethru' ?
                                <h3 className='invalid-meal-text'>Invalid meal: Please make sure each meal has 1 entree and 2 sides.</h3>
                                : <h3 className='invalid-meal-text'>Invalid meal: Please make sure each meal has 1 entree.</h3>
                            }
                            
                            <h4 className='invalid-meal-text-worker' style={{margin: "10px"}}>*Worker meals may have extra items.</h4>
                        </div> : <div className='add-item-to-meal'>
                            {
                                orderType === 'drivethru' ?
                                <h3 className='add-item-to-meal-text' style={{margin: "10px"}}>Please select 1 entree and 2 sides to add to the meal.</h3>
                                : <h3 className='add-item-to-meal-text' style={{margin: "10px"}}>Please select 1 entree to add to the meal.</h3>
                            }
                        </div>
                    }
                </div>
                <div className='options-div scrollable'>
                    <h3 className='options-text'>Entrees</h3>
                    <div className='entree-items grid'>
                        {
                            foodItems.length > 0 && fetchError === 0 ? foodItems.filter(item => item.type === 'entree').map(item =>
                                <ItemCard onSelect={() => addItem('entree', item.name, item.price, item.foodid, item.mealprice)} name={item.name} key={item.name} price={item.price} mealprice={item.mealprice}/>
                            ) : fetchError === 0 ? <h3>Loading entrees...</h3> : <h4 style={{color: 'red'}}>Error loading entrees</h4>
                        }
                    </div>
                    <h3 className='options-text'>Sides</h3>
                    <div className='side-items grid'>
                        {
                            foodItems.length > 0 && fetchError === 0 ? foodItems.filter(item => item.type === 'side').map(item =>
                                <ItemCard onSelect={() => addItem('side', item.name, item.price, item.foodid)} name={item.name} key={item.name} price={item.price}/>
                            ) : fetchError === 0 ? <h3>Loading sides...</h3> : <h4 style={{color: 'red'}}>Error loading sides</h4>
                        }
                    </div>
                    <h3 className='options-text'>Misc</h3>
                    <div className='misc-items grid'>
                        {
                            foodItems.length > 0 && fetchError === 0 ? foodItems.filter(item => item.type === 'extra').map(item =>
                                <ItemCard onSelect={() => addItem('extra', item.name, item.price, item.foodid)} name={item.name} key={item.name} price={item.price}/>
                            ) : fetchError === 0 ? <h3>Loading extras...</h3> : <h4 style={{color: 'red'}}>Error loading extras</h4>
                        }
                    </div>
                </div>
                <div className='current-order-div scrollable'>
                    <h5 className='current-order-heading'>Current order</h5>
                    <div className='current-order-body'>
                        {
                            currentOrder.sort((a, b) => a.orderNum - b.orderNum).map((item, idx) => item.itemType === 'alacarte' ? 
                                <OrderItemNew key={idx} itemNum={item.orderNum} itemType='alacarte' item={item.order} itemPrice={item.price} onDelete={deleteItem} onAddItem={setAddMeal}/>
                                : 
                                <OrderItemNew key={idx} isWorkerMeal={item.isWorkerMeal} itemNum={item.orderNum} itemType='meal' item={item.order} itemPrice={item.price} onDelete={deleteItem} onAddItem={setAddMeal} onDeleteMealItem={deleteMealItem} isValid={item.isValid}/>
                                )
                        }
                    </div>
                </div>
                <div className='total-cost-div'>
                    <h3>Total: ${currentTotal.toFixed(2)}</h3>
                    
                </div>
                <div className='order-buttons-div'>
                    <Link to='/home'>
                        <Button buttonText='Home' />
                    </Link>
                    <CancelButton className='cancel-order-button' buttonText='Cancel Order' onClickFunction={() => cancelOrder()}/>
                    {
                        currentTotal > 0 && allMealsValid ? <div className='to-order-page'>
                            <Link to='/payment' state={{ total: currentTotal, order: currentOrder, orderType: orderType, currentItemNum: currentItemNum }} >
                                <Button buttonText='Payment' />
                            </Link>
                        </div> : null
                    }
                </div>
            </div>
        </div>
    )
}

export default TakeOrderNew;